import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"bv-form-layout__item\" ...attributes>\n  {{yield}}\n</div>",{ moduleName: "volta/components/bv-form-layout/item.hbs" })